import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { CirclePlus } from "lucide-react";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import CustomInput from "../../../components/UI/PageInput/CustomInput";
import { jurisOptions } from "../../../utils/jurisdictionDetail";
import { jurisArr } from "../../../utils/jurisdictionDetail";
import OfficerViewDetailsDialog from "../dialogs/OfficerViewDetailsDialog";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import {
  phoneValidation,
  emailValidation,
  noSpaceOnlyValidation,
} from "../../../validations/formValidations";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import { getHierarchy } from "../../../functions/getHierarchy";
import HierarchyView from "../../../components/common/HierarchyView";

const AddOfficerForm = ({ officerSetup, sendData, loading, successResponse }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useForm();

  const accessLevel = watch("accessLevel");
  const accessId = watch("accessId");

  // Modify setup data for the form fields
  const parentOptions = officerSetup[jurisArr[accessLevel - 1]] || [];
  const parentLevelName = jurisOptions[accessLevel - 1]?.name ?? "";

  // Get Hierarchy View data
  const getHierData = parentOptions.find((d) => d.id === accessId);
  const hierarchyList = getHierarchy(getHierData, parentLevelName);

  useEffect(() => {
    if (accessLevel) {
      setValue("accessId", "");
    }
  }, [accessLevel]);

  const onSubmit = (data) => {
    const updatedData = { ...data, password: "password" };
    sendData(updatedData, reset);
  };

  return (
    <>
      <div className="form-container ">
        <CenteredHeading title="Add Officer" />
        <form
          className="form-border max-w-5xl mx-auto w-95%"
          onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        >
          <div className="flex gap-2">
            <div className="w-full">
              <CustomInput
                type="text"
                name="name"
                labelText="Name *"
                placeholder="Enter"
                register={{
                  ...register("name", {
                    ...noSpaceOnlyValidation,
                    required: "Please Enter a name",
                  }),
                }}
                error={errors.name}
              />
            </div>
            <div className="w-full">
              <CustomInput
                type="text"
                name="phoneNumber"
                labelText="Phone No. *"
                placeholder="Enter"
                register={{
                  ...register("phoneNumber", {
                    ...phoneValidation,
                    required: "Please Enter phone number",
                  }),
                }}
                error={errors.phoneNumber}
              />
            </div>
          </div>
          <CustomInput
            type="text"
            name="email"
            labelText="Email *"
            placeholder="Enter"
            register={{
              ...register("email", {
                ...emailValidation,
                required: "Please Enter a email",
              }),
            }}
            error={errors.email}
          />
          <div className="flex gap-2">
            <div className="w-full">
              <SearchDropdown
                name="accessLevel"
                label="Jurisdiction Level *"
                keyName="name"
                id="id"
                options={jurisOptions}
                setValue={setValue}
                control={control}
                selectedVal={accessLevel}
                error={errors.accessLevel}
                showOptionId={true}
                unSort={true}
              />
            </div>

            <div className="w-full">
              <SearchDropdown
                name="accessId"
                label={`Select ${parentLevelName} *`}
                keyName="name"
                id="id"
                options={parentOptions}
                setValue={setValue}
                control={control}
                selectedVal={accessId}
                disabled={!parentOptions.length}
                error={errors.accessId}
                showOptionId={true}
                search={true}
              />
            </div>
          </div>
          {parentOptions.length !== 0 && <HierarchyView list={hierarchyList} />}
          <div className="addBtn---wrap">
            <p className="addWrap">
              <PrimaryButton
                btnText={!loading ? "Add Officer" : "Adding..."}
                loading={loading}
                Icon={CirclePlus}
                size={18}
              />
            </p>
            <p className="grayWrap">
              <GrayButton
                btnText="Clear"
                width="w-40"
                onClick={() => reset()}
              />
            </p>
          </div>
        </form>
      </div>
      {successResponse && (
        <OfficerViewDetailsDialog viewDetails={successResponse} />
      )}
    </>
  );
};

export default AddOfficerForm;
